import { InfoOutlined } from '@mui/icons-material'
import { Chip } from '@mui/material'
import { ProductOrderStatus } from '@services/dtos'
import { ProductOrderReceptionStatusRender, ProductOrderStatusLabels } from '@utils/constants'

interface Props {
  status: ProductOrderStatus
  text?: string
}

export const ChipProductOrderStatus = ({ status, text }: Props) => {
  const config = ProductOrderReceptionStatusRender[status] ?? { icon: InfoOutlined, color: 'grey' }
  const label = ProductOrderStatusLabels[status] ?? status
  const Icon = config.icon

  return (
    <Chip
      sx={{
        borderRadius: 2,
        height: 'auto',
        '& .MuiChip-label': {
          display: 'block',
          whiteSpace: 'normal',
          paddingTop: 0.5,
          paddingBottom: 0.5,
          lineHeight: 1.2,
        },
      }}
      icon={<Icon color='white' sx={{ fontSize: '14px !important' }} />}
      label={text ?? label}
      style={{ backgroundColor: config.color, color: 'white', paddingLeft: 2 }}
      size="small"
      variant="filled"
    />
  )
}
